import React from "react";
import ReactDOM from "react-dom";
import { isPromise } from "@/helpers/isPromise";
import Modal from ".";
import { ReactRender } from "../ReactRender";

function modalConfirm({ content, ...options }) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const unMount = () => {
    ReactDOM.unmountComponentAtNode(container);
    try {
      container.parentElement?.removeChild(container);
    } catch (e) {
      console.warn(e);
    }
  };

  const handleConfirm = () => {
    const req = options.onConfirm?.();
    if (isPromise(req)) {
      req.then(() => {
        unMount();
      });
    }
    return req;
  };

  const handleCancel = () => {
    unMount();
    return options.onClose?.();
  };

  ReactRender(
    <Modal
      closeable
      open
      {...options}
      onConfirm={handleConfirm}
      onClose={handleCancel}
    >
      {content}
    </Modal>,
    container
  );
}

export default modalConfirm;
